import { ChangeDetectorRef, Directive, inject, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Model } from '@df/catalog/model';
import { Route } from '@df/catalog/route/route';
import { App } from '@df/core/app';
import { AfterContentInitDirectiveService } from '@df/ui/common/after-content-init.directive';
import { Subscription } from 'rxjs';

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class CatalogViewComponentDef implements OnInit, OnDestroy {
    protected subscriptions: Subscription = new Subscription();

    /**
     * Target model
     */
    protected model?: Model;
    protected modelArray: Model[] = [];

    private initiated = false;

    protected activatedRoute = inject(ActivatedRoute);
    private _ref = inject(ChangeDetectorRef);
    private app = inject(App);
    private afterContentInit = inject(AfterContentInitDirectiveService);

    /**
     * Listen to router updates
     */
    ngOnInit(): void {
        this.afterContentInit.lock(this);
        this.subscriptions.add(this.setRouteSubscription());
        this.initiated = true;
    }

    protected setRouteSubscription(): Subscription {
        return this.activatedRoute.data.subscribe(data => {
            this.applyRoute(data['route'] as Route);
        });
    }

    protected applyRoute(route: Route) {
        // route update must be here an not later since setModel triggers processing
        this.app.meta.updateRoute(route);
        // tracker.tick('Catalog route chagne', route.id);

        let model: Model | undefined;

        if (route?.data?.target && route.data.targetType && this.app.resources[route.data.targetType]) {
            model = this.app.resources[route.data.targetType].getExisting(route.data.target);
        } else {
            model = undefined;
            this.afterContentInit.unlock(this);
        }

        if (model !== this.model) {
            this.setModel(model);
            this.afterContentInit.unlock(this);
        }
    }

    protected setModel(model?: Model): void {
        this.model = model;
        this.modelArray = model ? [model] : [];

        // tracker.tick('Catalog model set');
        this.detectChanges();
    }

    detectChanges(): void {
        if (this.initiated) {
            this._ref.detectChanges();
        }
    }

    /**
     * Cleanup
     */
    ngOnDestroy(): void {
        this.app.meta.currentRoute = undefined;
        this.subscriptions.unsubscribe();
        this.afterContentInit.unlock(this);
    }
}
